import React from 'react';

import { Button, Flex, InlineNotification, Text, Box } from '@lucidhq/lucidium';

import { useCampaignManager } from '~/components/CampaignManager/CampaignManagerProvider';
import { t } from '~/utils/i18n';

export const CreativeDiscrepancy = ({
  amount,
  uploaded
}: {
  amount?: number;
  uploaded?: number;
}) => {
  const { goToStep, steps } = useCampaignManager();

  return (
    <Flex
      data-testid="review-discrepancy-block"
      lss={{ flexDirection: 'column' }}
    >
      <InlineNotification
        lss={{
          mb: 'xxl'
        }}
        palette="danger"
        title={t('campaignManager.review.creatives.discrepancy.title')}
      >
        <Box>
          <Text>
            {t('campaignManager.review.creatives.discrepancy.description')}
          </Text>
          <Text lss={{ display: 'block' }}>
            {t('campaignManager.review.creatives.discrepancy.amount')} {amount}
          </Text>
          <Text lss={{ display: 'block' }}>
            {t('campaignManager.review.creatives.discrepancy.uploaded')}{' '}
            {uploaded}
          </Text>
        </Box>
      </InlineNotification>

      <Flex lss={{ justifyContent: 'center', gap: '1rem' }}>
        <Button emphasis="medium" onClick={() => goToStep(steps.DETAILS.id)}>
          {t('campaignManager.review.creatives.discrepancy.adjustCreatives')}
        </Button>
        <Button
          emphasis="medium"
          onClick={() => goToStep(steps.MEDIA_TRACKING.id)}
        >
          {t('campaignManager.review.creatives.discrepancy.addRemoveCreatives')}
        </Button>
      </Flex>
    </Flex>
  );
};
